export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-information-line text-sm"></i>
            关于我们
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            关于五一吃瓜网
          </h2>
          <p className="text-foreground-500 text-sm mt-2">了解平台背后的故事与使命</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-bold text-xl">
                瓜
              </span>
              <div>
                <h3 className="font-heading font-bold text-xl text-foreground-900">五一吃瓜网</h3>
                <p className="text-foreground-500 text-sm">最新最全的娱乐八卦资讯平台</p>
              </div>
            </div>

            <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              <p>
                五一吃瓜网成立于2024年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为广大吃瓜爱好者提供最新、最全、最及时的娱乐资讯服务，涵盖明星动态、综艺热点、网红八卦、影视资讯等多个内容领域。
              </p>
              <p>
                平台采用智能内容聚合技术，每日从海量信源中精选优质内容，确保用户获取到的每一条资讯都经过严格筛选与核实。我们的编辑团队由资深娱乐媒体人和专业内容运营组成，全天候关注行业动态。
              </p>
              <p>
                五一吃瓜网始终坚持「快、准、全」的运营理念——第一时间追踪热点事件，准确还原事实真相，全面覆盖各类娱乐话题。无论是顶流明星的最新动态，还是小众圈层的热门话题，你都能在这里找到。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="text-center p-4 rounded-xl bg-background-100">
                <div className="font-heading font-bold text-2xl text-primary-500 mb-1">2024</div>
                <div className="text-xs text-foreground-500">平台创立年份</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100">
                <div className="font-heading font-bold text-2xl text-primary-500 mb-1">50+</div>
                <div className="text-xs text-foreground-500">专业编辑团队</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100">
                <div className="font-heading font-bold text-2xl text-primary-500 mb-1">百万级</div>
                <div className="text-xs text-foreground-500">日均内容浏览量</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}